import { Feature, FeatureCollection, MultiPolygon, Polygon } from '@turf/turf';
import { FeatureUnioner } from './FeatureUnioner';
import { IAuthorizableGeometry } from './AuthorizationFeatureCollection';

export class CroppedTileFeatureMerger {
    static inject = () => [FeatureUnioner];
    constructor(private unioner: FeatureUnioner){}
    merge = (featureCollection: FeatureCollection<IAuthorizableGeometry, { GLOBAL_ID: string }>): FeatureCollection<IAuthorizableGeometry, { GLOBAL_ID: string }> => {
        const globalIdMap: any = {};
        for (const feature of featureCollection.features) {
            if (!globalIdMap[feature.properties.GLOBAL_ID]) {
                globalIdMap[feature.properties.GLOBAL_ID] = feature;
            }
            //TODO: we're not merging line strings, but aren't yet cropping them when creating the authorization tile
            // so may not be an issue
            // FUD - if a Military Training Route spans 2 z10 tiles, do we get a redundant advisory? (not sure)
            // FUD - if a Military Training Route spans 2 z10 tiles, does it get deduped by mapbox (very likely)
            else if (['Polygon', 'MultiPolygon'].includes(feature.geometry.type)) {
                globalIdMap[feature.properties.GLOBAL_ID] = this.unioner.getUnion(globalIdMap[feature.properties.GLOBAL_ID], feature as Feature<Polygon | MultiPolygon>);
                globalIdMap[feature.properties.GLOBAL_ID].properties = feature.properties;
            }
        }

        return {
            type: 'FeatureCollection',
            features: Object.keys(globalIdMap).map(key => globalIdMap[key])
        };
    }
}
